export default __webpack_public_path__ + "images/RX.3a746b8.png";